// シェーダのコンパイルとユニフォーム位置のキャッシュ。

export class GLProgram {
  readonly program: WebGLProgram
  private uniforms = new Map<string, WebGLUniformLocation | null>()

  constructor(private gl: WebGL2RenderingContext, vertSrc: string, fragSrc: string, readonly name = 'program') {
    const vs = compile(gl, gl.VERTEX_SHADER, vertSrc, name + '.vert')
    const fs = compile(gl, gl.FRAGMENT_SHADER, fragSrc, name + '.frag')
    const p = gl.createProgram()
    if (!p) throw new Error('createProgram に失敗')
    gl.attachShader(p, vs)
    gl.attachShader(p, fs)
    gl.linkProgram(p)
    gl.deleteShader(vs)
    gl.deleteShader(fs)
    if (!gl.getProgramParameter(p, gl.LINK_STATUS) && !gl.isContextLost()) {
      const log = gl.getProgramInfoLog(p)
      gl.deleteProgram(p)
      throw new Error(`シェーダのリンクに失敗 (${name}): ${log}`)
    }
    this.program = p
  }

  use(): void {
    this.gl.useProgram(this.program)
  }

  loc(name: string): WebGLUniformLocation | null {
    if (!this.uniforms.has(name)) this.uniforms.set(name, this.gl.getUniformLocation(this.program, name))
    return this.uniforms.get(name) ?? null
  }

  dispose(): void {
    this.gl.deleteProgram(this.program)
  }
}

function compile(gl: WebGL2RenderingContext, type: number, src: string, name: string): WebGLShader {
  const s = gl.createShader(type)
  if (!s) throw new Error('createShader に失敗')
  gl.shaderSource(s, src)
  gl.compileShader(s)
  if (!gl.getShaderParameter(s, gl.COMPILE_STATUS) && !gl.isContextLost()) {
    const log = gl.getShaderInfoLog(s)
    gl.deleteShader(s)
    throw new Error(`シェーダのコンパイルに失敗 (${name}): ${log}`)
  }
  return s
}
